import ConfigNode from 'Model/ConfigNode';

class GraphConfig extends ConfigNode {
  static className = 'GraphConfig';

  constructor() {
    super('graphConfig');
  }

  getNodeLimit() {
    return this.get('nodeLimit');
  }

  setNodeLimit(val, params = {}) {
    this.attribute('nodeLimit').add(val);
    return this.save(params);
  }

  resetNodeLimit(params = {}) {
    return this.setNodeLimit(5000, params);
  }

  static load() {
    return super.load('graphConfig', this);
  }
}

export default GraphConfig;
